import React from 'react';

export const ShieldHome = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.991" viewBox="0 0 20 19.991">
            <path id="shield-home" d="M20,1.628A1.633,1.633,0,0,0,18.37.006H1.632A1.632,1.632,0,0,0,.01,1.639L0,7.756A12.623,12.623,0,0,0,9.884,19.98a.833.833,0,0,0,.333,0A12.621,12.621,0,0,0,19.99,7.668ZM15.686,8.022a.417.417,0,0,1-.269.735h-.833a.417.417,0,0,0-.417.417v3.75a.417.417,0,0,1-.417.417H11.667a.417.417,0,0,1-.417-.417V11.049a1.25,1.25,0,0,0-2.5,0v1.875a.417.417,0,0,1-.417.417H6.25a.417.417,0,0,1-.417-.417V9.174a.417.417,0,0,0-.417-.417H4.583a.417.417,0,0,1-.269-.735L9.731,3.438a.417.417,0,0,1,.538,0Z" transform="translate(0 -0.006)" />
        </svg>
    )
}